import { css } from 'styled-components'
import {
  loaderDotScaleAnim,
  popUpSlideDownAnim,
  popUpSlideUpAnim,
  pageFadeInAnim,
  pageFadeOutAnim,
  iconRotateAnim,
  fadeInAnim,
  modalFadeOutAnim,
} from './TransitionsKeyframes'

export const TransitionsAnim = () => {
  const popUpSlideUp = css`
    animation: ${popUpSlideUpAnim} 0.55s 1 forwards;
  `
  const popUpSlideDown = css`
    animation: ${popUpSlideDownAnim} 0.33s 1 forwards;
  `
  const pageFadeOut = css`
    animation: ${pageFadeOutAnim} 0.55s 1 forwards;
  `
  const pageFadeIn = css`
    animation: ${pageFadeInAnim} 0.5s 1 forwards;
  `
  const iconRotate = css`
    animation: ${iconRotateAnim} 0.5s forwards;
  `
  const loaderDotScale = css`
    animation: ${loaderDotScaleAnim} 1.66s 6;
  `
  const fadeIn = css`
    animation: ${fadeInAnim} 1.3s forwards;
  `
  const modalFadeOut = css`
    animation: ${modalFadeOutAnim} 0.5s forwards;
  `
  return {
    popUpSlideUp,
    popUpSlideDown,
    pageFadeOut,
    pageFadeIn,
    iconRotate,
    loaderDotScale,
    fadeIn,
    modalFadeOut,
  }
}
